import { DrawerDesignTokens } from '@primeuix/themes/types/drawer';
import componentCommon from '../one-ds-tokens/OneDS-Component-Common.json';
import { t, tNum } from '../token-utils';

// https://github.com/primefaces/primeuix/blob/main/packages/themes/src/presets/aura/drawer/index.ts
const dr = componentCommon.drawer;

export const DrawerTelekomDT: DrawerDesignTokens = {
  root: {
    background: t(dr.background),
    color: t(dr.color),
    borderColor: t(dr.border.color),
  },
  header: {
    padding: t(dr.header.padding),
  },
  title: {
    fontWeight: tNum(dr.title.font.weight),
    fontSize: t(dr.title.font.size),
  },
  content: {
    padding: `${t(dr.content.padding.top)} ${t(dr.content.padding.right)} ${t(dr.content.padding.bottom)} ${t(dr.content.padding.left)}`,
  },
  footer: {
    padding: t(dr.footer.padding),
  },
};
